import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  /* Layout */
  .ant-layout {
    background-color: #fff;
  }

  /* Content */
  .ant-layout-content {
    position: relative;
    height: calc(100vh - 113px);
  }

  /* Button */
  .ant-btn {
    border-radius: .25rem;

    &.right-icon {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;

      .anticon {
        vertical-align: -0.225em;

        & + span {
          margin: 0 0.5rem 0 0;
        }
      }
    }
  }

  /* Card */
  .ant-card {
    border-color: rgba(0, 0, 0, 0.12);
    border-radius: 0.5rem;
  }

  /* Menu */
  .ant-menu {
    &.condensed {
      .ant-menu-item  {
        height: auto;
        margin: 0.75rem 0;
        padding: 0 0.5rem;
        line-height: 20px;

        &:first-child {
          margin-top: 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &:not(.ant-menu-horizontal) {
      .ant-menu-item-selected {
        background-color: transparent;
      }
    }
   
    .ant-menu-item-selected a, 
    .ant-menu-item-selected a:hover {
      color: rgba(0, 0, 0, 0.65);
    }
  }

  /* Space */
  .ant-space-vertical {
    width: 100%;
  }

  /* ScrollbarsCustom */
  .ScrollbarsCustom-Thumb {
    background-color: rgba(0,0,0,.3) !important;
  }

  .ScrollbarsCustom-Track {
    width: 8px !important;
    top: 3px !important;
    background-color: rgba(0,0,0,.05) !important;
  }

  /* NProgress */
  #nprogress .bar {
    background: #43aa58;
    height: 4px;
  }
`;
